export default __webpack_public_path__ + "static/winter1-6f741a7d42629bada2c586fbad74886d.webp";